import _slicedToArray from "@babel/runtime/helpers/slicedToArray";var fontFamilies = {
  lighter: 'GothamLight',
  light: 'GothamBook',
  medium: 'GothamMedium',
  bold: 'GothamBold'
};

var fontFamilyEntries = Object.entries(fontFamilies);

export var font = fontFamilyEntries.reduce(function (obj, _ref) {var _ref2 = _slicedToArray(_ref, 2),fontKey = _ref2[0],fontFamily = _ref2[1];
  obj[fontKey] = "\"".concat(fontFamily, "\", Montserrat, \"Century Gothic\", Futura, sans-serif");
  return obj;
}, /** @type {{[key: string]: string}} */{});
//# sourceMappingURL=fonts.js.map